import './App.css';
import Navbar           from './components/Navbar';
import Hero             from './components/Hero';
import Menu             from './components/Menu';
import About            from './components/About';
import Features         from './components/Features';
import InstagramGallery from './components/InstagramGallery';
import Contact          from './components/Contact';
import Footer           from './components/Footer';

function App() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Menu />
        <About />
        <Features />
        <InstagramGallery />
        <Contact />
      </main>
      <Footer />
    </>
  );
}

export default App;
